import GenericFetch from 'framework/genericfetch'
import VoltError from 'VoltError'

/**
 * Mapping Error Table from the Backend
 */
const ERROR_BACKEND_MAPPING = {
    'No credentials sent!': () => VoltError.codes.PLAYER_ERROR_DUE_TO_INVALID_TOKEN,
}

/**
 * Fetching API class.
 */
export default class Fetch extends GenericFetch {
    constructor(config, otherApis = {}) {
        super(config, 'mediacorp', ERROR_BACKEND_MAPPING)
        this.registerErrors(ERROR_BACKEND_MAPPING)
    }
}
